module.exports = __webpack_public_path__ + "img/Deportivo-Alaves.9eb07b54.png";